import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { AxnSession } from "@idw-types/data/management-console/axn";

type GetActiveAxnAdminSessionsRequestResponse = {
    sessions: Array<AxnSession>;
};

export const getActiveAxnSessionsRequest = async (): Promise<{ data: GetActiveAxnAdminSessionsRequestResponse, error: any }> => {
    const route = apiRoutes.managementConsole.axn.sessions.active;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};